import { Tab, TabGroup, TabList, TabPanel, TabPanels } from "@headlessui/react";
import TaskCard from "../todoList/taskCard";
import listingImg from "../../images/listingImg.jpg";
import { useEffect, useState } from "react";
import moment from "moment";
import ScheduleCard from "./SchedulerCard";

const SchedulerList = ({ schedules, selectedDate, getHomeData }) => {
  const [categories, setCategories] = useState([
    {
      name: "Planlagt",
      schedules: [],
    },
    {
      name: "Afsluttet",
      schedules: [],
    },
  ]);
  const [showDate, setShowDate] = useState("");
  useEffect(() => {
    let pendingTask = [];
    let completedTask = [];
    if (schedules && schedules.length > 0) {
      schedules.map((val) => {
        let data = {
          ...val,
          sched_start_time: moment(val.sched_start_time).format("HH:mm A"),
          sched_end_time: moment(val.sched_end_time).format("HH:mm A"),
        };
        if (+val.sched_status === 0) {
          pendingTask.push(data);
        } else {
          completedTask.push(data);
        }
      });
    }
    setCategories([
      {
        name: "Planlagt",
        schedules: pendingTask,
      },
      {
        name: "Afsluttet",
        schedules: completedTask,
      },
    ]);

    const formattedDate = moment(selectedDate).format("dddd, MMMM Do");
    setShowDate(formattedDate);
  }, [schedules]);

  console.log("categories", categories);

  return (
    <div className="w-full max-w-4xl mx-auto mt-4 p-4">
      <h2 className="text-lg font-semibold bg-theme text-center text-white py-2 px-4 rounded-2xl mb-4">
        {showDate} tidsplaner
      </h2>
      <TabGroup>
        <TabList className="flex justify-center">
          {categories.map(({ name, id }, index) => (
            <Tab
              key={id}
              className={`py-3 px-4 text-sm font-normal text-white focus:outline-none bg-[#8A8A8A] data-[selected]:bg-[#03A067] w-full 
              ${index === 0 ? "rounded-s-2xl" : ""} 
              ${index === categories.length - 1 ? "rounded-r-2xl" : ""}`}
            >
              {name}
            </Tab>
          ))}
        </TabList>
        <TabPanels className="mt-5">
          {categories.map(({ name, schedules }) => (
            <TabPanel key={name}>
              <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
                {schedules && schedules.length > 0 ? (
                  schedules.map((schedule, index) => (
                    <ScheduleCard
                      key={index}
                      {...schedule}
                      getHomeData={getHomeData}
                    />
                  ))
                ) : (
                  <h1>Ingen tidsplaner tilgængelige</h1>
                )}
              </div>
            </TabPanel>
          ))}
        </TabPanels>
      </TabGroup>
    </div>
  );
};

export default SchedulerList;
